import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, PopupRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { Industry } from '../../models/common/industry.model';
import { ResourcePageLink } from '../../models/resource-page-link/resource-page-link.model';
import { PrimaryIndustryService } from '../../services/primary-industry.service';
import { ResourcePageService } from '../../services/resource-page.service';
import { Base } from '../base/base';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'safetydirector-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  providers: [AuthService]
})
export class NavMenuComponent extends Base implements OnInit, OnDestroy {
  private BusyA;
  private BusyB;
  private readonly _destroying$ = new Subject<void>();
  public isExpanded = false;
  selectedIndustry: string | null = null;
  resourcePages: ResourcePageLink[];
  primaryIndustries: Industry[];
  public searchString: string | null = null;

  public localStorageKey = 'memic-favorite-resources';

  public collapse() {
    this.isExpanded = false;
  }

  public toggle() {
    this.isExpanded = !this.isExpanded;
  }

  constructor(
    private authService: MsalService,
    private router: Router,
    private primaryIndustryService: PrimaryIndustryService,
    private resourcePageService: ResourcePageService,
  ) {
    super();
  }

  ngOnInit(): void {
    const primaryIndustryTerm = 'primaryIndustry';
    this.selectedIndustry = this.getIndustry();

    this.user = this.getUserDetailsFromLocalStorage();

    this.BusyA = this
      .resourcePageService
      .getResourcePageNavigation()
      .subscribe(result => {
        this.resourcePages = result;
      });
    this.BusyB = this
      .primaryIndustryService
      .getIndustries()
      .subscribe(result => {
        this.primaryIndustries = result;
      });
  }

  //set the industry in local storage
  updateIndustry(industry: string): void {
    this.selectedIndustry = industry;
    this.setIndustry(industry);
    // Force a page reload.
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // This was added since "Auto Dealer" was getting double encoded
    let currentUrl = decodeURIComponent(this.router.url)
    this.router.navigate([currentUrl]);
  }

  logout(popup?: boolean) {
    
    this.deleteUserDetailFromLocalStorage();
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.authService.logoutRedirect();
    }
  }

  public filterResources() {
    let searchStringCopy = this.searchString;
    this.searchString = null;

    // Force a page reload.
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.navigate(
      ['/resource-library'],
      { queryParams: { searchString: searchStringCopy } }
    );
  }

  public routeToFavorites() {
    this.router.navigate([`/favorite-resources`]);
  }

  public getFavoritesCount() {
    let favorites = JSON.parse(localStorage.getItem(this.localStorageKey)!);

    return favorites != null ? favorites.length : 0;
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }
  }
}
